(function () {
    'use strict';

    angular.module('app').factory('EquipmentService', EquipmentService);

    EquipmentService.$inject = ['$rootScope', 'API', '$http'];

    function EquipmentService($rootScope, API, $http) {
        var service = {};

        /**
         * Return equipment controllers
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetControllers = function (loyalty_id, params, callback) {
            API.get(`/equipment/${loyalty_id}/controllers?` + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        }


        /**
         * Add equipment controller
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {Object} post_data - Equipment controller data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CreateController = function (loyalty_id, post_data, callback) {
            API.post(`/equipment/${loyalty_id}/controllers`, post_data, function (success, response) {
                callback(success, response);
            });
        };


        /**
         * Return equipment controller
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetController = function (loyalty_id, controller_id, callback) {
            API.get(`/equipment/${loyalty_id}/controllers/${controller_id}`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         * Change equipment controller
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {Object} data - Equipment controller data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangeController = function (loyalty_id, controller_id, data, callback) {
            API.patch(`/equipment/${loyalty_id}/controllers/${controller_id}`, data, function (success, response) {
                callback(success, response);
            });
        };


        /**
         * Return equipment controller end user equipments
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {Object} params - Parameters filter
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetControllerEquipments = function (loyalty_id, controller_id, params, callback) {
            API.get(`/equipment/${loyalty_id}/controllers/${controller_id}/equipments?` + paramsToUrlQueryEncodeURIComponent(params), function (success, data) {
                callback(success, data);
            });
        }

        /**
         * Add equipment for controller
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {Object} post_data - Equipment data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.CreateControllerEquipment = function (loyalty_id, controller_id, post_data, callback) {
            API.post(`/equipment/${loyalty_id}/controllers/${controller_id}/equipments`, post_data, function (success, response) {
                callback(success, response);
            });
        };

        /**
         * Return equipment info
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {string} equipment_id - Equipment ID
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.GetControllerEquipment = function (loyalty_id, controller_id, equipment_id, callback) {
            API.get(`/equipment/${loyalty_id}/controllers/${controller_id}/equipments/${equipment_id}`, function (success, data) {
                callback(success, data);
            });
        }

        /**
         * Change equipment data
         *
         * @param {string} loyalty_id - Loyalty ID
         * @param {string} controller_id - Controller ID
         * @param {string} equipment_id - Equipment ID
         * @param {Object} data - Equipment data
         * @param {requestCallback} callback - The callback that handles the response.
         */
        service.ChangeControllerEquipment = function (loyalty_id, controller_id, equipment_id, data, callback) {
            API.patch(`/equipment/${loyalty_id}/controllers/${controller_id}/equipments/${equipment_id}`, data, function (success, response) {
                callback(success, response);
            });
        };


        return service;
    }

})();

